import { useEffect, useState } from 'react';
import * as LDClient from 'launchdarkly-js-client-sdk';
import { getLDClientId } from '../utils/getLdClientId';

export function useBootstrapLD(envName: string, userId: number | undefined) {
  const [downloadMobileAppWebBannerFF, setDownloadMobileAppWebBannerFF] = useState<boolean | null>(
    null,
  );
  const [downloadMobileAppWebBannerReady, setDownloadMobileAppWebBannerReady] = useState(false);
  const [mobileAppWebBannerUniversalLinksFF, setMobileAppWebBannerUniversalLinksFF] = useState<
    boolean | null
  >(null);
  const [mobileAppWebBannerUniversalLinksReady, setMobileAppWebBannerUniversalLinksReady] =
    useState(false);
  const [mobileAppWebBannerLoyaltyProgramFF, setMobileAppWebBannerLoyaltyProgramFF] = useState<
    boolean | null
  >(null);
  const [mobileAppWebBannerLoyaltyProgramReady, setMobileAppWebBannerLoyaltyProgramReady] =
    useState(false);
  const [ordersCtaFF, setOrdersCtaFF] = useState<boolean | null>(null);
  const [ordersCtaReady, setOrdersCtaReady] = useState(false);
  const [webRatingsAndReviewInGlobalNavDropDownFF, setWebRatingsAndReviewInGlobalNavDropDownFF] =
    useState<boolean | null>(null);
  const [
    webRatingsAndReviewInGlobalNavDropDownReady,
    setWebRatingsAndReviewInGlobalNavDropDownReady,
  ] = useState(false);
  const [ccToastNotificationFF, setCcToastNotificationFF] = useState<boolean | null>(null);
  const [ccToastNotificationReady, setCcToastNotificationReady] = useState(false);

  const clientId = getLDClientId(envName);

  useEffect(() => {
    const ldclient = LDClient.initialize(clientId, {
      key: userId?.toString() || 'anonymous',
    });
    ldclient.on('ready', () => {
      const downloadMobileAppWebBanner = ldclient.variation(
        'download-mobile-app-web-banner',
        false,
      );
      setDownloadMobileAppWebBannerFF(downloadMobileAppWebBanner);
      setDownloadMobileAppWebBannerReady(true);

      const mobileAppWebBannerUniversalLinks = ldclient.variation(
        'mobile-app-web-banner-universal-links',
        false,
      );
      setMobileAppWebBannerUniversalLinksFF(mobileAppWebBannerUniversalLinks);
      setMobileAppWebBannerUniversalLinksReady(true);

      const mobileAppWebBannerLoyaltyProgram = ldclient.variation(
        'mobile-app-web-banner-loyalty-program',
        false,
      );
      setMobileAppWebBannerLoyaltyProgramFF(mobileAppWebBannerLoyaltyProgram);
      setMobileAppWebBannerLoyaltyProgramReady(true);

      const ordersCta = ldclient.variation('orders-cta', false);
      setOrdersCtaFF(ordersCta);
      setOrdersCtaReady(true);

      const webRatingsAndReviewInGlobalNavDropDown = ldclient.variation(
        'web-ratings-and-review-in-global-nav-drop-down',
        false,
      );
      setWebRatingsAndReviewInGlobalNavDropDownFF(webRatingsAndReviewInGlobalNavDropDown);
      setWebRatingsAndReviewInGlobalNavDropDownReady(true);

      const ccToastNotification = ldclient.variation('cc-toast-notification', false);
      setCcToastNotificationFF(ccToastNotification);
      setCcToastNotificationReady(true);
    });

    ldclient.on('change:download-mobile-app-web-banner', (value) => {
      setDownloadMobileAppWebBannerFF(value);
    });
    ldclient.on('change:orders-cta', (value) => {
      setOrdersCtaFF(value);
    });
    ldclient.on('change:web-ratings-and-review-in-global-nav-drop-down', (value) => {
      setWebRatingsAndReviewInGlobalNavDropDownFF(value);
    });
    ldclient.on('cc-toast-notification', (value) => {
      setCcToastNotificationFF(value);
    });
  }, [userId, clientId]);

  return {
    downloadMobileAppWebBannerFF,
    downloadMobileAppWebBannerReady,
    mobileAppWebBannerUniversalLinksFF,
    mobileAppWebBannerUniversalLinksReady,
    mobileAppWebBannerLoyaltyProgramFF,
    mobileAppWebBannerLoyaltyProgramReady,
    ordersCtaFF,
    ordersCtaReady,
    webRatingsAndReviewInGlobalNavDropDownFF,
    webRatingsAndReviewInGlobalNavDropDownReady,
    ccToastNotificationFF,
    ccToastNotificationReady,
  };
}

export default useBootstrapLD;
